import * as React from 'react';

import { useDeveloperProps } from './hooks';
import { DeveloperInfo } from '../../../../components/BottomAuthorBlockNew';
import { CardSectionNew } from '../../../../components/CardSectionNew';
import { PhonesContainer } from '../../../AsideContacts/PhonesContainer';
import { CallBackButtonContainer } from '../../../CallBackButton';

export const DeveloperInfoContainer: React.FC = () => {
  const props = useDeveloperProps();

  if (!props) {
    return null;
  }

  return (
    <CardSectionNew>
      <DeveloperInfo
        contactButton={<PhonesContainer trackingAction="Open_card_agent_block" size="XS" />}
        callButton={<CallBackButtonContainer size="XS" placeType="agent_block" />}
        {...props}
      />
    </CardSectionNew>
  );
};
